<template>
  <v-card flat class="kpi-card">
    <v-layout row wrap style="padding: 0px 12px;">
      <v-flex xs12 sm6 md6>
        <div
          class="kpi-strip"
          :style="`background: ${gradient};`"
        ></div>
        <div class="kpi-label">{{ label }}</div>
        <div class="kpi-value" v-if="valFormat === 'currency'">{{ value | currency }}</div>
        <div class="kpi-value" v-else>{{ value }}</div>
      </v-flex>
      <v-flex xs12 sm6 md6>
        <div class="kpi-meta">{{ meta }}</div>
        <div class="kpi-chart">
          <svg viewBox="0 0 100 26" width="100%" height="24" v-html="chart">
          </svg>
        </div>
      </v-flex>
    </v-layout>
  </v-card>
</template>

<script>
export default {
  name: 'StatCard',
  props: {
    label: {
      type: String,
      required: true
    },
    value: {
      type: [String, Number],
      required: true
    },
    meta: {
      type: String,
      required: true
    },
    gradient: {
      type: String,
      required: true
    },
    chart: {
      type: String,
      required: true
    },
    valFormat: {
      type: String,
      default: 'number'
    }
  }
}
</script>

<style scoped>
:root {
  --lw-blue: #0b63ce;
  --lw-blue-light: #1f7ae0;
  --lw-bg: #f4f6fb;
  --lw-border: #dfe3ee;
  --lw-text-main: #1f2933;
  --lw-text-muted: #6b7280;
  --lw-accent-green: #059669;
  --lw-accent-teal: #0f766e;
  --lw-accent-orange: #f97316;
  --lw-accent-red: #ef4444;
  --lw-accent-purple: #7c3aed;
}

/* KPI card */
.kpi-card {
  position: relative;
  border-radius: 10px;
  border: 1px solid #dfe3ee;
  padding: 10px 12px 8px;
  height: 100%;
}

.kpi-strip {
  position: absolute;
  left: 0;
  top: 0;
  right: 0;
  height: 4px;
  border-radius: 10px 10px 0 0;
}

.kpi-label {
  font-size: 11px;
  text-transform: uppercase;
  letter-spacing: 0.08em;
  color: #6b7280;
  margin-top: 6px !important;
}

.kpi-value {
  font-size: 20px;
  font-weight: 600;
  margin-top: 2px !important;
  color: #1f2933;
}

.kpi-meta {
  font-size: 11px;
  color: #6b7280;
  margin-top: 2px !important;
  padding-left: 53px;
}

.kpi-chart {
  margin-top: 4px !important;
}
</style>
